"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      componentList: [],
      userType: null,
      components: [{
        title: '搜索框',
        showType: 3,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/7b16f3d13f594e048e17562c30470f5c839f8zxkvt.png',
        settingInfo: {
          newSwitch: false,
          newNamePosition: null,
          newTextColor: null,
          newDivPosistion: null,
          newTextPosition: 1,
          isLogo: '',
          searchDefault: '',
          showType: 3,
          placeholderPositionEnum: null,
          bgImg: null,
          bgColor: null,
          searchPadding: {
            pt: 14,
            pb: 14,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          position: {
            pt: 0,
            pb: 0,
            pl: 0,
            pr: 0
          },
          fixedPt: 10,
          fixedPl: 10
        }
      }, {
        title: '轮播图',
        showType: 1,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/c024b427e6584b608eb6a2f9198b7a4ampysngr78h.png',
        bannerPadding: {
          pt: 10,
          pb: 10,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          bannerHeight: 160,
          showType: 1,
          banner: [{
            url: ''
          }],
          bgImg: null,
          bgColor: null,
          bannerPadding: {
            pt: 10,
            pb: 10,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          }
        }
      }, {
        title: '导航组',
        showType: 2,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        navPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          showType: 2,
          menus: [{
            url: ''
          }],
          bgImg: null,
          bgColor: null,
          navPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          navHeight: 50,
          navWidth: 50,
          showBtw: 0,
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          }
        }
      }, {
        title: '图片魔方',
        showType: 4,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/c20ee94d49d341f5a523b224b3eb2c4cmhma0n1m7e.png',
        settingInfo: {
          showType: 4,
          imgType: null,
          activity: [],
          bgImg: null,
          bgColor: null,
          activePadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          offlineSupplierId: null
        }
      }, {
        title: '图片热区',
        showType: 5,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        imgActPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          showType: 5,
          stylebgImg: null,
          stylebgColor: null,
          imgActPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          }
        }
      }, {
        title: '商品列表',
        showType: 6,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/fc86fee9cf894aaead51a83cbd8be3eed6fs4ccnvq.png',
        settingInfo: {
          goodsShowType: 1,
          showTitle: 1,
          newNamePosition: null,
          showPrice: 1,
          showPage: 1,
          newPricePosition: null,
          pageLimit: 10,
          newPagesStyle: null,
          newPagesColor: null,
          newIsSwiper: null,
          newVideoLoop: null,
          pagesStyleTyepe: '',
          bgImg: null,
          bgColor: null,
          newBorderColor: null,
          goodsPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15,
            midP: 15
          },
          borderRadius: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15,
            midP: 15
          },
          midPadding: 1,
          marketLists: [{
            roderSort: null
          }],
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          showType: 6,
          titleAlign: 'center',
          sortType: 1,
          titleColor: null
        }
      }, {
        title: '拼团商品',
        showType: 7,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/daab19a35e1848ad8778f2ce9728f8e7161yp2fz4z.png',
        settingInfo: _defineProperty(_defineProperty(_defineProperty({
          goodsType: null,
          showType: 7,
          skuId: '',
          pinPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          showPage: 1,
          pageLimit: 10,
          titleColor: null,
          bgImg: null
        }, "bgImg", null), "bgColor", null), "formMargin", {
          mt: 0,
          mb: 0,
          ml: 15,
          mr: 15
        })
      }, {
        title: '促销列表',
        showType: 8,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/dc90f11f13a8425e9c3e9dea419e2c3ezm7q1yhhov.png',
        settingInfo: {
          titleAlign: '',
          goodsShowType: 1,
          showTitle: 1,
          showCatePopup: 0,
          cateBgColor: null,
          newNamePosition: '',
          showPrice: 1,
          showPage: 1,
          pageLimit: 10,
          newPagesStyle: '',
          newPagesColor: '',
          bgImg: null,
          bgColor: null,
          newBorderColor: '',
          titleStyleOne: 1,
          pagesStyleTyepe: '',
          showType: 8,
          marketLists: [{
            headtitle: '',
            subHeadtitle: '',
            roderSort: ''
          }],
          goodsPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15,
            midP: 15
          },
          borderRadius: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          sortType: 1,
          titleColor: null,
          midPadding: 1
        }
      }, {
        title: '视频列表',
        showType: 9,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        moviePadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          showType: 9,
          showTitle: 1,
          movieLists: [{
            url: ''
          }],
          bgImg: null,
          bgColor: null,
          moviePadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          }
        }
      }, {
        title: '信息收集',
        showType: 10,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        formPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          titleAlign: 'center',
          showType: 10,
          showTitle: 1,
          bgImg: null,
          bgColor: null,
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          }
        }
      }, {
        title: '核销二维码',
        showType: 11,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        formPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          titleAlign: 'center',
          showType: 11,
          showTitle: 1,
          bgImg: null,
          bgColor: null,
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          }
        }
      }, {
        title: '城市定位',
        showType: 12,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        formPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          fixedPt: 10,
          fixedPl: 10,
          textTips: '',
          bgImg: null,
          bgColor: null,
          fixed: 1,
          showType: 12,
          showTitle: 1,
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          borderRadius: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          position: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          }
        }
      }, {
        title: '新闻公告',
        showType: 13,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/841ef616d7fa471ab9135a7317c03ef55ulz6165gl.png',
        formPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        },
        settingInfo: {
          showType: 13,
          showTitle: 1,
          logoUrl: '',
          newEdit: 1,
          tipsTitle: '',
          openUrl: '',
          textUrl: "",
          textType: '',
          typeName: '',
          loop: '',
          bgImg: null,
          bgColor: null,
          borderColor: '',
          borderRadius: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          textPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          }
        }
      }, {
        title: '权益兑换按钮',
        showType: 14,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        settingInfo: {
          showType: 14,
          buttonText: '确认兑换',
          textPosition: 1,
          // 1=居左, 2=居中, 3=居右
          themeColor: '#1989fa',
          buttonWidth: 120,
          buttonHeight: 44,
          cornerType: 1,
          // 1=统一设置, 2=分开设置
          borderRadius: 4,
          bgImg: '',
          bgPic: '',
          bgColor: '#1989fa',
          marginType: 1,
          // 1=统一设置, 2=分开设置
          margin: 0
        }
      }, {
        title: '抽奖按钮',
        showType: 15,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        settingInfo: {
          keys: '',
          positionText: '',
          textColor: '',
          textSize: '',
          buttonWidth: '',
          buttonHeight: '',
          borderRadius: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          buttonBgColor: '',
          bgColor: '',
          color: '',
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          showType: 15
        }
      }, {
        title: '富文本',
        showType: 16,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        settingInfo: {
          description: '',
          bgColor: '',
          formPadding: {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          showType: 16
        }
      }, {
        title: '客服插件',
        showType: 17,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        settingInfo: {
          msgType: '1',
          msgUrl: '',
          bgImg: '',
          iconColor: '',
          textName: '',
          textColor: '',
          bgColor: '',
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 15,
            mr: 15
          },
          formPadding: {
            pt: 15,
            pb: 15,
            pl: 15,
            pr: 15
          },
          positionType: '2',
          showType: 17
        }
      }, {
        title: '实名认证',
        showType: 18,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/366f90db672248cf8f97e8945117d710f23fx7eikr.png',
        settingInfo: {
          showType: 18,
          promptContent: ''
        }
      }, {
        title: '活动商品',
        showType: 19,
        icon: 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/crmebimage/public/product/2024/10/29/fc86fee9cf894aaead51a83cbd8be3eed6fs4ccnvq.png',
        settingInfo: {
          showType: 19,
          activityType: 1,
          bgImg: '',
          bgUrl: '',
          goodsInfo: {},
          roderSort: 1,
          goodsTagImg: '',
          interactionType: 2,
          goodsShowType: 2,
          goodsUrl: '',
          cardDisplayTypes: [1],
          cardDisplayType: 1,
          bgCornerType: 1,
          goodsCornerType: 1,
          bgLayout: {
            ml: 0,
            mr: 0,
            mt: 0,
            mb: 0,
            tl: 0,
            tr: 0,
            bl: 0,
            br: 0
          },
          goodsLayout: {
            ml: 0,
            mr: 0,
            mt: 0,
            mb: 0,
            tl: 0,
            tr: 0,
            bl: 0,
            br: 0
          },
          formMargin: {
            mt: 0,
            mb: 0,
            ml: 0,
            mr: 0
          }
        }
      }]
    };
  },
  computed: {
    filteredComponents: function filteredComponents() {
      // 管理员显示所有组件
      if (this.userType === 1) {
        return this.components;
      }
      // 小程序客户：隐藏搜索框、拼团、信息收集、核销二维码、城市定位、权益兑换、抽奖、客服、实名认证、活动商品
      if (Number(this.userType) === 5) {
        var _allowedShowTypes = [1, 2, 4, 5, 6, 8, 13, 16];
        return this.components.filter(function (item) {
          return _allowedShowTypes.includes(item.showType);
        });
      }
      // 其他非管理员
      var allowedShowTypes = [1, 2, 3, 4, 5, 6, 8, 11, 13, 16, 18, 19];
      return this.components.filter(function (item) {
        return allowedShowTypes.includes(item.showType);
      });
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    addCompont: function addCompont(item) {
      this.$emit('addComItems', item);
    }
  }
};